import {inject, Injectable, InjectionToken, Signal} from "@angular/core";

// List of feature flags that framework components may check. Add/remove entries here when framework-level flags are needed.
export const frameworkFeatureFlagKeys = [] as const;
export type FrameworkFeatureFlag = typeof frameworkFeatureFlagKeys[number];

export interface FrameworkFeatureFlagsContext
{
    readonly state: Signal<Record<string, { enabled?: boolean }>>;
    requestFlag(flagKey: FrameworkFeatureFlag): Promise<void>;
}

export const FRAMEWORK_FEATURE_FLAGS =
    new InjectionToken<FrameworkFeatureFlagsContext>("FRAMEWORK_FEATURE_FLAGS");

export function frameworkFeatureFlagsContextFactory(state: FrameworkFeatureFlagsContext["state"],
                                                    requestFlag: FrameworkFeatureFlagsContext["requestFlag"]): FrameworkFeatureFlagsContext
{
    return {state, requestFlag};
}

@Injectable({providedIn: "root"})
export class FrameworkFeatureFlagsService
{
    private readonly m_context = inject(FRAMEWORK_FEATURE_FLAGS, {optional: true});

    public async isEnabled(flagKey: FrameworkFeatureFlag): Promise<boolean>
    {
        await this.m_context?.requestFlag(flagKey);
        return this.m_context?.state()?.[flagKey]?.enabled ?? false;
    }
}
